const { users } = require('../utils/utils');

/* eslint-disable indent */
const getFrontSnippetPlaceholder = (formData, i18n) => `
  <html>
  <head>
    <script src="https://sdk.mercadopago.com/js/v2"></script>
  </head>
  <body>
    <div id="statusScreenBrick_container"></div>
    <script>
      const mp = new MercadoPago('YOUR_PUBLIC_KEY', {
        locale: '${formData.language}'
      });
      const bricksBuilder = mp.bricks();
      const renderStatusScreenBrick = async (bricksBuilder) => {
        const settings = {
          initialization: {
            paymentId: '${formData.paymentId}', // ${i18n.gettext('valor del procesamiento a realizar')}
          },
          customization: {
            visual: {
              ${!formData.showExternalReference ? 'showExternalReference: false,' : ''}
              ${!formData.hideStatusDetails ? 'hideStatusDetails: true,' : ''}
              ${!formData.hideTransactionDate ? 'hideTransactionDate: true,' : ''}
              style: {
                theme: ${
                  `'${formData.theme}'` || 'default'
                }, // | 'dark' | 'bootstrap' | 'flat'
              }
            },
          },
          callbacks: {
            onReady: () => {
              // ${i18n.gettext('callback llamado cuando Brick esté listo')}
            },
            onError: (error) => {
              // ${i18n.gettext('callback llamado para todos los casos de error de Brick')}
            },
          },
        };
        window.statusScreenBrickController = await bricksBuilder.create('statusScreen', 'statusScreenBrick_container', settings);
      };
      renderStatusScreenBrick(bricksBuilder);
    </script>
  </body>
  </html>
  `;

module.exports = { getFrontSnippetPlaceholder };
